export default "__VITE_ASSET__j5xpANdr__"